import React, { useState } from "react";

import { formatNumericCurrency, useGetFarms, useTranslation } from "utils";

import { VESTING_PERCENTAGE, VESTING_YEARS } from "consts";

import { ExtraInfo, LinedCard, LinkMoreInfo, PayoutInVerification, Spin, TimelineStatusLabel } from "components";

// If the payout is partial, preVerificationPayout can be used to show what the total payout would have been
export const PayoutInVerificationCard = ({ modules, loading, className, children, payout, preVerificationPayout, payoutAtVerificationStart, status, year }) => {
  const { t } = useTranslation("modules");
  const [showDrawer, setShowDrawer] = useState();
  const { currentFarm } = useGetFarms();

  const preVerificationValue = preVerificationPayout
    ? {
        min: Number(preVerificationPayout),
        max: Number(preVerificationPayout),
      }
    : null;

  const handleOpenDrawer = (e) => {
    e.stopPropagation();
    setShowDrawer(true);
  };

  return (
    <>
      <LinedCard
        className={`payout-card ${className}`}
        dataTestId="payout-in-verification-card"
        primary={
          loading ? (
            <div className="payout-card-content">{<Spin />}</div>
          ) : (
            <>
              <TimelineStatusLabel status={status || "inVerification"} />

              <PayoutInVerification
                payout={payout}
                preVerificationPayout={preVerificationValue}
                payoutAtVerificationStart={payoutAtVerificationStart}
                rejected={status === "rejected"}
                modules={modules}
                caption={t("payoutInVerificationCard.payoutAmount", { year })}
                subCaption={
                  payout !== 0 && (
                    <div className="vesting-info">
                      <LinkMoreInfo onClick={(e) => handleOpenDrawer(e)}>
                        {payout > 0
                          ? t("payoutInVerificationCard.vestingInfo", {
                              payoutNow: formatNumericCurrency((1 - VESTING_PERCENTAGE) * payout, { currency: currentFarm.carbonProgram.currency }),
                              payoutVesting: formatNumericCurrency(VESTING_PERCENTAGE * payout, { currency: currentFarm.carbonProgram.currency }),
                              year: year + VESTING_YEARS,
                            })
                          : t("payoutInVerificationCard.negativePayout")}
                      </LinkMoreInfo>
                    </div>
                  )
                }
              />
            </>
          )
        }
        secondary={children}
      />

      <ExtraInfo setVisible={setShowDrawer} type={payout > 0 ? "payout-overview" : "negative-payout"} visible={showDrawer} />
    </>
  );
};
